import "./styles/App.css";
import { BrowserRouter } from "react-router-dom";
import DBMGate from "./components/CometChatLogin/DBMGate";
import { AppContextProvider } from "./context/AppContext";
import { Navigate, Route, Routes } from "react-router-dom";
import Credentials from "./components/CometChatLogin/CometChatAppCredentials";
import DBMWorkspace from "./dbm/DBMWorkspace";
import MaintenancePage from "./dbm/MaintenancePage";

interface IAppProps {
  loggedInUser?: CometChat.User;
  theme?: string;
}

const MAINTENANCE_MODE = process.env.REACT_APP_MAINTENANCE_MODE === "true";

function App(props: IAppProps) {
  const AppRoutes = () => {
    return (
      <AppContextProvider>
        <Routes>
          <Route path="/" element={<Navigate to="/home" replace />} />
          <Route path="login" element={<DBMGate />} />
          <Route path="home" element={<DBMWorkspace />} />
          <Route path="credentials" element={<Credentials />} />
        </Routes>
      </AppContextProvider>
    );
  };

  if (MAINTENANCE_MODE) {
    return <MaintenancePage />;
  }

  return (
    <div>
      <div className="App">
        <BrowserRouter>
          <AppRoutes />
        </BrowserRouter>
      </div>
    </div>
  );
}

export default App;
